import {notificationTypes} from './notificationTypes';

/** The automation-rule notification types, gated together on the orchestration flag. */
export const orchestrationNotificationTypes = [
  notificationTypes.ORCHESTRATION_RULE_TRIGGERED,
  notificationTypes.ORCHESTRATION_RULE_RAN_FOR_RECORD,
  notificationTypes.ORCHESTRATION_RULE_RAN_FOR_TEAM,
  notificationTypes.ORCHESTRATION_RULE_NOTIFIED_YOU,
  notificationTypes.ORCHESTRATION_RUN_AWAITING_CONFIRMATION,
  notificationTypes.ORCHESTRATION_RUN_STOPPED,
  notificationTypes.ORCHESTRATION_RULE_APPROVAL_REQUESTED,
] as const;
